const authTokenKey = 'authTokenKey'

export const saveSecurityToken = (authentication) => {
  try {
    localStorage.setItem(
      authTokenKey,
      JSON.stringify({ ...authentication, dataHoraToken: Date.now().valueOf() })
    )
    return authentication
  } catch (err) {
    // TODO log err
    throw err
  }
}

export const removeSecurityToken = () => {
  try {
    localStorage.removeItem(authTokenKey)
    return authTokenKey
  } catch (err) {
    // TODO log err
    throw err
  }
}

export const getAuthentication = () => {
  try {
    const item = localStorage.getItem(authTokenKey)
    return item ? JSON.parse(item) : item
  } catch (err) {
    // TODO log err
    throw err
  }
}

export const updateSecurityToken = (authentication) => {
  try {
    const autenticacaoComContexto = getAuthentication()
    autenticacaoComContexto.tokenJwt = authentication.tokenJwt
    autenticacaoComContexto.refreshToken = authentication.refreshToken
    autenticacaoComContexto.userFingerPrint = authentication.userFingerPrint
    autenticacaoComContexto.dataHoraToken = Date.now().valueOf()

    localStorage.setItem(authTokenKey, JSON.stringify(autenticacaoComContexto))
    return authentication
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const tempoAquisicaoTokenEmMinutos = () => {
  if (getAuthentication()) {
    const now = Date.now().valueOf()

    const { dataHoraToken } = getAuthentication()

    if (dataHoraToken !== 'undefined') {
      return (now - dataHoraToken) / 60000
    }
  }
}

export const getUserFingerPrint = () => {
  let auth = getAuthentication()
  if (auth) {
    return auth.userFingerPrint
  }
  return null
}
